import React from 'react'
import { ReactComponent as LoomisSvg} from '../../assets/svgs/clients/Loomis.svg';

const LoomisLogo = () => (
    <div>
        <LoomisSvg/>
    </div>
)

export default LoomisLogo